let currentController = null;
const sectionCache = new Map();

function buildFetchUrl(url, sectionId) {
  const separator = url.indexOf("?") === -1 ? "?" : "&";
  return url + separator + "sections=" + sectionId;
}

function prefetch(url, sectionId) {
  const fetchUrl = buildFetchUrl(url, sectionId);
  if (sectionCache.has(fetchUrl)) return;

  fetch(fetchUrl)
    .then((r) => r.json())
    .then((data) => {
      if (data[sectionId]) sectionCache.set(fetchUrl, data[sectionId]);
    })
    .catch(() => {});
}

function ajaxFilter(url) {
  const mainCollection = document.querySelector('[data-section-type="collection-template"]');
  if (!mainCollection) return;
  const sectionId = mainCollection.id;
  const fetchUrl = buildFetchUrl(url, sectionId);

  if (sectionCache.has(fetchUrl)) {
    mainCollection.innerHTML = sectionCache.get(fetchUrl);
    history.pushState({ path: url }, "", url);
    return;
  }

  if (currentController) currentController.abort();
  currentController = new AbortController();
  mainCollection.classList.add("is-loading");

  fetch(fetchUrl, { signal: currentController.signal })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      const html = data[sectionId];
      if (!html) return;

      sectionCache.set(fetchUrl, html);
      mainCollection.innerHTML = html;
      history.pushState({ path: url }, "", url);
    })
    .catch(function (err) {
      if (err.name !== "AbortError")
        console.error("Collection filter fetch failed:", err);
    })
    .finally(function () {
      currentController = null;
      mainCollection.classList.remove("is-loading");
    });
}

document.addEventListener("click", function (e) {
  const link = e.target.closest(".filter, .filter_clear-all");
  if (!link) return;
  e.preventDefault();
  ajaxFilter(link.getAttribute("href"));
});

function initFilterPrefetch() {
  const sectionEl = document.querySelector('[data-section-type="collection-template"]');
  if (!sectionEl) return;

  document.querySelectorAll(".filter, .filter_clear-all").forEach((link) => {
    prefetch(link.getAttribute("href"), sectionEl.id);
  });
}

if ("requestIdleCallback" in window) {
  requestIdleCallback(initFilterPrefetch);
} else {
  setTimeout(initFilterPrefetch, 200);
}